// extracted by css-extract-rspack-plugin
export default {"loader":"loader-VpFKOw","infoIcon":"infoIcon-mkEyA7","tooltip":"tooltip-cwG3vQ"};